<div class="sv-skeleton--not-implemented">
  <div>{{ model.getType() + " question type renderer is not implemented yet." }}</div>
  <div>{{ model.value }}</div>
</div>
